import { render, staticRenderFns } from "./Ziliao.vue?vue&type=template&id=d5f39c90&scoped=true&"
import script from "./Ziliao.vue?vue&type=script&lang=js&"
export * from "./Ziliao.vue?vue&type=script&lang=js&"
import style0 from "./Ziliao.vue?vue&type=style&index=0&id=d5f39c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f39c90",
  null
  
)

export default component.exports